import {plotFftRatioFourDUnit} from "../utils/map_utils";
import FFTRatioFourDH from "./FFTRatioFourDH";

class FFTRatioFourD extends FFTRatioFourDH {
    id = "fftRatio4d";
    label = "FFT Ratio 4D V";
    defaultVisible = this.props.tileViewerState[this.id];

    process = (v, xc, yc, margin, sizeOfMarker, countRed, countYellow, source, rescanThresh, rescanThresh2) => {
        let type = 'V';
        let {rescanThreshValue1, rescanThreshValue2} = this.props;
        plotFftRatioFourDUnit(v, this.props.slide, xc, yc, margin, sizeOfMarker, this.layer.getSource(),
            rescanThreshValue1, rescanThreshValue2, type);
        if (v["NORTH"]) {
            for (let crop = 0; crop < v["NORTH"].length; crop++) {
                if (v['NORTH'][crop] <= 500 + rescanThresh * 500)
                    countYellow += 1;
                if (v['NORTH'][crop] <= rescanThresh * 1000)
                    countRed += 1;
            }
        }
    }
}

export default FFTRatioFourD;
